import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
    SiteStructure,
    ENV_SHAPE_PROP_TYPE,
    REQUEST_SHAPE_PROP_TYPE,
    USER_SHAPE_PROP_TYPE,
    FOOTER_LINKS_SHAPE_PROP_TYPE,
} from '@eventbrite/site-structure';

export default class Page extends PureComponent {
    static propTypes = {
        env: ENV_SHAPE_PROP_TYPE.isRequired,
        request: REQUEST_SHAPE_PROP_TYPE.isRequired,
        user: USER_SHAPE_PROP_TYPE.isRequired,
        footerLinks: FOOTER_LINKS_SHAPE_PROP_TYPE.isRequired,
        isLoading: PropTypes.bool,
    };

    render() {
        const {
            env,
            request,
            user,
            footerLinks,
            isLoading,
            children,
            featureFlags,
        } = this.props;

        return (
            <SiteStructure
                env={env}
                request={request}
                user={user}
                footerLinks={footerLinks}
                isLoading={isLoading}
                fullScreenMain={true}
                featureFlags={featureFlags}
            >
                {children}
            </SiteStructure>
        );
    }
}
